<template>
    <div>
        <base-modal :isOpen="value" :title="$t('edit') | capitalize" @close="close">
            <template #body>
                <vs-row class="mt-4"> 
                    <vs-col>
                        <vs-input :label="$t('client') | capitalize" :placeholder="$t('client') | capitalize"
                            v-model="form.clientName" class="w-full " disabled />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col>
                        <vs-input :label="$t('quantity') | capitalize" :placeholder="$t('quantity') | capitalize"
                          type="number"  v-model="form.quantity" class="w-full" />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col>
                        <vs-input type="number" :label="$t('price')" :placeholder="$t('price')" v-model="form.unitPrice"
                            class="w-full" />
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col>
                        <vs-input type="text" label="Total" placeholder="Total" :value="total" class="w-full" disabled />
                    </vs-col>
                </vs-row>
                <vs-alert :active="alert" class="mt-4">
                    Please check the fields.
                </vs-alert>
                 
            </template>

            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                    <vs-button color="success" icon="save" type="flat" @click="update" :disabled="alert">
                        {{ $t('save') | upperCase }}
                    </vs-button>
                </div>

            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch, computed, getCurrentInstance } from 'vue'
import BaseModal from '@/views/app/components/BaseModal.vue'


const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Title' },
    item: { type: Object, default: () => ({ id: '', client_id: '', client_name: '', quantity: 0, unit_price: ''}) }
})

const emit = defineEmits(['update', 'input'])

const form = ref({
    id: '',
    clientId: '',
    clientName: null,
    quantity: '',
    unitPrice: ''
})

const total = computed(() => {
  const val = Number(form.value.unitPrice) * (form.value.quantity)
  return val === 0 ? "0" : val.toFixed(2)
})

const alert = computed(() => {
  const f = form.value

  const isInvalid = (val) =>
    val === ''  ||
    val === null ||
    val === undefined ||
    isNaN(val) ||
    Number(val) < 0
  
  
  return (
    isInvalid(f.unitPrice) ||
    isInvalid(f.quantity)
  )
})

watch(() => props.value, (newValue) => {
    if (newValue) {
        resetForm()
        form.value.id = props.item.id
        form.value.clientId = props.item.client_id
        form.value.clientName = props.item.client_name
        form.value.quantity = props.item.quantity
        form.value.unitPrice = props.item.unit_price
    }
})



const resetForm = () => {
    form.value.id = ''
    form.value.clientId = ''
    form.value.clientName = ''
    form.value.quantity = null
    form.value.unitPrice = ''
}


const close = () => {
    emit('input', false)
}

const update = () => {
    //console.log({ ...form.value,total:total.value })
    emit('update', { ...form.value,total:total.value })
}

</script>

<style></style>